import React from 'react';
import SessionGate from './SessionGate';
import AITermsWrapper from './AITermsWrapper';
import AgreementGate from './AgreementGate';

interface AuthenticatedGateProps {
  children: React.ReactNode;
  onTermsAccepted?: () => void;
}

/** Session validation + AI terms + org agreement/suspension gating for authenticated portal routes. */
const AuthenticatedGate: React.FC<AuthenticatedGateProps> = ({ children, onTermsAccepted }) => (
  <SessionGate>
    <AITermsWrapper onTermsAccepted={onTermsAccepted}>
      <AgreementGate>{children}</AgreementGate>
    </AITermsWrapper>
  </SessionGate>
);

export default AuthenticatedGate;
